import { Reveal, Kicker } from "@/components/Reveal";
import { IMAGES } from "@/content";
import { MapPin } from "lucide-react";

const MAP_SRC = "https://maps.google.com/maps?q=40.3721427,16.546242&t=k&z=15&output=embed";

export const LocationSection = ({ t }) => (
  <section id="location" data-testid="location-section" className="relative py-24 sm:py-32 px-6 bg-[#1A1715]">
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <Kicker>{t.location.kicker}</Kicker>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F0E6] max-w-3xl">
          {t.location.title}
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-10 mt-12 max-w-4xl">
        <Reveal delay={0.15}>
          <p className="text-base text-[#A8A294] leading-relaxed">{t.location.body1}</p>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="text-base text-[#A8A294] leading-relaxed">{t.location.body2}</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 grid-rows-2 gap-3 mt-16 h-[440px] sm:h-[520px]" data-testid="location-gallery">
        <Reveal className="col-span-2 row-span-2 overflow-hidden rounded-sm">
          <img src={IMAGES.g2} alt="Calanchi al tramonto" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[2s]" />
        </Reveal>
        <Reveal delay={0.1} className="col-span-1 row-span-1 overflow-hidden rounded-sm">
          <img src={IMAGES.g4} alt="Calanchi e vegetazione" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[2s]" />
        </Reveal>
        <Reveal delay={0.2} className="col-span-1 row-span-2 overflow-hidden rounded-sm">
          <img src={IMAGES.g1} alt="Paesaggio dei Calanchi" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[2s]" />
        </Reveal>
        <Reveal delay={0.3} className="col-span-1 row-span-1 overflow-hidden rounded-sm">
          <img src={IMAGES.g3} alt="Texture d'argilla" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[2s]" />
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 border border-[#F4F0E6]/10 rounded-sm overflow-hidden">
          <div className="flex items-center gap-3 px-6 py-4 bg-[#0D0B0A]">
            <MapPin size={16} className="text-[#D4A373]" />
            <div>
              <p className="text-sm text-[#F4F0E6]">{t.location.mapTitle}</p>
              <p className="text-xs text-[#A8A294]">{t.location.mapDesc}</p>
            </div>
          </div>
          <iframe
            title="Legend — Calanchi di Pisticci"
            data-testid="location-map"
            src={MAP_SRC}
            className="w-full h-[420px] border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
